export default __webpack_public_path__ + "static/media/pic2.3440f078.png";